import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { asyncAction } from "../util/redux.js";
import { getRentContractId } from "./store.js";
export var loadRentContract = function loadRentContract(rentContractId) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState, context) {
      var rentContract;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return context.api.rentContracts.getRentContract({
              rentContractId: rentContractId
            });
          case 2:
            rentContract = _context.sent;
            dispatch({
              type: "RENT_CONTRACTS/RENT_CONTRACT_LOADED",
              payload: {
                rentContract: rentContract
              }
            });
            return _context.abrupt("return", rentContract);
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }();
};
export var clearRentContract = function clearRentContract(reservationNo) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(dispatch, getState, context) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            dispatch({
              type: "RENT_CONTRACTS/RENT_CONTRACT_CLEAR",
              payload: {
                reservationNo: reservationNo
              }
            });
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x4, _x5, _x6) {
      return _ref2.apply(this, arguments);
    };
  }();
};
export var updateRentContractAfterLogin = function updateRentContractAfterLogin(rentContractId) {
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(dispatch, getState, context) {
      var _yield$context$api$re, tariffOptionChanged, rentObjectPropertyRemoved, mileagePackagesRemoved;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return context.api.rentContracts.updateRentContractAfterLogin({
              rentContractId: rentContractId
            });
          case 2:
            _yield$context$api$re = _context3.sent;
            tariffOptionChanged = _yield$context$api$re.tarifOptionUpdated;
            rentObjectPropertyRemoved = _yield$context$api$re.rentobjectPropertyRemoved;
            mileagePackagesRemoved = _yield$context$api$re.mileagePackagesRemoved;
            dispatch({
              type: "RENT_CONTRACTS/RENT_CONTRACT_ASSIGNED_TO_USER",
              payload: {
                rentContractId: rentContractId,
                tariffOptionChanged: tariffOptionChanged,
                rentObjectPropertyRemoved: rentObjectPropertyRemoved,
                mileagePackagesRemoved: mileagePackagesRemoved
              }
            });
          case 7:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function (_x7, _x8, _x9) {
      return _ref3.apply(this, arguments);
    };
  }();
};
export var loadDeliveryAddress = function loadDeliveryAddress(rentContractId) {
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(dispatch, getState, context) {
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return dispatch(asyncAction({
              typePrefix: "RENT_CONTRACTS/DELIVERY_ADDRESS",
              loadPayload: function () {
                var _loadPayload = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
                  return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) switch (_context4.prev = _context4.next) {
                      case 0:
                        _context4.t0 = rentContractId;
                        _context4.next = 3;
                        return context.api.rentContracts.getDeliveryAddress({
                          rentContractId: rentContractId
                        });
                      case 3:
                        _context4.t1 = _context4.sent;
                        return _context4.abrupt("return", {
                          rentContractId: _context4.t0,
                          deliveryAddress: _context4.t1
                        });
                      case 5:
                      case "end":
                        return _context4.stop();
                    }
                  }, _callee4);
                }));
                function loadPayload() {
                  return _loadPayload.apply(this, arguments);
                }
                return loadPayload;
              }()
            }));
          case 2:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return function (_x10, _x11, _x12) {
      return _ref4.apply(this, arguments);
    };
  }();
};
export var activatePromocode = function activatePromocode(promocode) {
  return /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7(dispatch, getState, context) {
      var rentContractId;
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            rentContractId = getRentContractId(getState());
            _context7.next = 3;
            return dispatch(asyncAction({
              typePrefix: "RENT_CONTRACTS/RENT_CONTRACT",
              loadPayload: function () {
                var _loadPayload2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
                  return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) switch (_context6.prev = _context6.next) {
                      case 0:
                        _context6.next = 2;
                        return context.api.rentContracts.activatePromocode({
                          promocode: promocode,
                          rentContractId: rentContractId
                        });
                      case 2:
                        _context6.t0 = _context6.sent;
                        return _context6.abrupt("return", {
                          rentContract: _context6.t0
                        });
                      case 4:
                      case "end":
                        return _context6.stop();
                    }
                  }, _callee6);
                }));
                function loadPayload() {
                  return _loadPayload2.apply(this, arguments);
                }
                return loadPayload;
              }()
            }));
          case 3:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));
    return function (_x13, _x14, _x15) {
      return _ref5.apply(this, arguments);
    };
  }();
};